import * as React from "react";
import {cx} from "emotion";

import "./tint-modal.scss";

import {cs}            from "@Common/react/chain-services";
import {DebounceCache} from "@Common/react/debounce-cache";
import {UseState}      from "@Common/react/use-state";

import {OpacitySelector} from "../../../common/opacity-selector/opacity-selector";
import {toCssPos}        from "../../../common/to-css-pos";

import {HueSelector} from "./hue-selector/hue-selector";

export const TintModal = ({color, strength, next}) => cs(
    ["show", (_, next) => UseState({next})],
    ({show}) => <>
        {next({
            show: (target, {direction}) => {
                const rect = target.getBoundingClientRect();
                show.onChange({
                    point: direction === "left" ? {
                        x: rect.x + 16,
                        y: rect.y + Math.floor(rect.height / 2),
                    } : {
                        x: rect.x + rect.width - 8,
                        y: rect.y - 2,
                    },
                    ...direction === "top" && {
                        arrowPoint: {
                            x: rect.x + Math.floor(rect.width / 2),
                            y: rect.y - 2,
                        },
                    },
                    direction,
                });
                // console.log(rect);
            },
        })}

        {show.value && cs(
            ["hueSelector", (_, next) => HueSelector({color, next})],
            ({hueSelector}) => (
                <div {...{
                    className: cx("tint-modal-0w2", "direction-" + show.value.direction),
                    onMouseDown: () => show.onChange(null),
                }}>

                    <div {...{
                        className: "box-anchor",
                        style: {
                            ...toCssPos(show.value.point),
                        },
                        onMouseDown: (e) => e.stopPropagation(),
                    }}>
                        <div className={cx("box", {expanded: hueSelector.opened})}>
                            {hueSelector.render({className: "hue-selector"})}

                            {cs(
                                ["debounce", (_, next) => DebounceCache({
                                    state: strength,
                                    delay: 100,
                                    next,
                                })],
                                ({debounce}) => OpacitySelector({
                                    state: debounce.state,
                                }),
                            )}
                        </div>
                    </div>
                    <div {...{
                        className: cx("arrow", {dark: show.value.direction === "left" && hueSelector.opened}),
                        style: {
                            ...toCssPos(show.value.arrowPoint ?? show.value.point),
                        },
                    }}/>
                </div>
            ),
        )}
    </>,
);
